<template>
  <div class="row mb-2">
    <div class="col-12">
      <h4>{{ $trans.get("__JSON__.Hourly rates") }}</h4>
    </div>
    <div class="col-12">
      <button class="btn btn-primary float-end" @click="addRate">
        {{ $trans.get("__JSON__.Add employerrate") }}
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <table class="table">
        <thead>
          <tr>
          <th>{{ $trans.get("__JSON__.Hourly rate") }}</th>
          <th>{{ $trans.get("__JSON__.Name") }}</th>
          <th class="w-10">{{ $trans.get("__JSON__.Actions") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rate, index) in rates">
            <td>{{ rate.hourlyrate }}</td>
            <td>{{ rate.name }}</td>
            <td>
              <button class="btn btn-sm text-primary" @click="edit(index)">
                <i class="fa fa-edit"></i>
              </button>
              <button class="btn btn-sm text-primary" @click="deleteRate(index)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal" tabindex="-1" id="ratemodal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="ratetitle"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <span v-if="errors['name']">
            <span v-for="error in errors['name']" class="text-danger">
              {{ error }}
            </span>
          </span>

          <div class="mb-3">
            <label for="name">{{ $trans.get("__JSON__.Name") }}</label>
            <input type="text" class="form-control" v-model="editrate.name" />
          </div>

          <span v-if="errors['hourlyrate']">
            <span v-for="error in errors['hourlyrate']" class="text-danger">
              {{ error }}
            </span>
          </span>

          <div class="mb-3">
            <label for="hourlyrate">{{ $trans.get("__JSON__.Hourly rate") }}</label>
            <input type="numeric" step="0.01" class="form-control" v-model="editrate.hourlyrate" />
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            {{ $trans.get("__JSON__.Close") }}
          </button>
          <button type="button" class="btn btn-primary" @click="save">
            {{ $trans.get("__JSON__.Save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EmployerRates",
  created() { },
  props: {
    employer_id: null,
  },
  data() {
    return {
      rates: null,
      editrate: {
        id: null,
        name: null,
        hourlyrate: null,
        employer_id: this.employer_id,
      },
      errors: [],
    };
  },
  watch: {},
  mounted() {
    this.fetchRates();
    console.log("Mounted");
  },
  methods: {
    addRate() {
      this.editrate = {
        id: null,
        name: null,
        hourlyrate: null,
        employer_id: this.employer_id,
      };
      $("#ratetitle").html(this.$trans.get("__JSON__.Create employer rate"));
      $("#ratemodal").modal("show");
    },
    edit(index) {
      console.log(index);
      this.editrate = this.rates[index];
      $("#ratetitle").html(this.$trans.get("__JSON__.Edit employer rate"));
      $("#ratemodal").modal("show");
    },
    deleteRate(index) {
      if (confirm("Are you sure you want to delete the employe rate?")) {
        axios
          .delete("/api/employerrates/" + this.rates[index].id)
          .then((resp) => {
            self.errors = [];
            this.fetchRates();
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          });
      }
    },
    save() {
      if (this.editrate.id != null) {
        axios
          .put("/api/employerrates/" + this.editrate.id, this.editrate)
          .then((resp) => {
            self.errors = [];
            this.fetchRates();
            $("#ratemodal").modal("hide");
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          });
      } else {
        axios
          .post("/api/employerrates", this.editrate)
          .then((resp) => {
            self.errors = [];
            this.fetchRates();
            $("#ratemodal").modal("hide");
          })
          .catch((error) => {
            console.log(error.response.data);
            this.errors = error.response.data.errors;
          });
      }
    },
    fetchRates() {
      axios
        .get("/api/employerrates", {
          params: {
            employer_id: this.employer_id,
          },
        })
        .then((resp) => {
          console.log(resp.data);
          this.rates = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped></style>
